var _jsxFileName = "/src/main/react/src/main/app/components/common/Pagination.js";
import { IconButton, Typography, Grid, Select, MenuItem } from "@material-ui/core";
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from "@material-ui/icons";
import React from "react";
import { LOCAL_STORAGE_ITEM_NAMES, Q_STRING, VALID_PAGE_SIZES } from "../domain/constants";
import { changeSearchValue } from "../../util/QueryStringUtil";
import { storeUserPreferenceInLocalStorage } from "../../util/StorageUtil";

/**
 * Pagination is essentially an interface. I just don't know how to make Java-style interfaces in ES6.
 * Consequently, every page you want to add Pagination to must have
 * 1. These fields in state:
 * - page
 * - totalPages
 * - totalElements
 * - loaded
 * - morePages
 * 2. The centeredContainer CSS
 * 3. A this.loadContent() function
 * 4. withRouter export so this.props gets location info
 */
export default function Pagination(state, self, classes, isTop) {
  const displayPage = state.page + 1 + (state.totalPages != null && state.totalPages !== 0 ? ' of ' + state.totalPages : '');
  const maxOnPage = (state.page + 1) * state.pageSize;
  const displayCount = "".concat(state.page * state.pageSize + 1, " - ").concat(maxOnPage > state.totalElements ? state.totalElements : maxOnPage, " of ").concat(state.totalElements, " results");
  if (state.totalElements != null && state.totalElements > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      spacing: 0,
      container: true,
      direction: 'column',
      justify: 'center',
      alignItems: 'center',
      alignContent: 'center',
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 17
      }
    }, isTop === true && [/*#__PURE__*/React.createElement(Grid, {
      item: true,
      justify: 'center',
      alignContent: 'center',
      wrap: 'nowrap',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 25
      }
    }, state.loaded != null && state.loaded === true && /*#__PURE__*/React.createElement(Typography, {
      style: {
        marginTop: '5px'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 29
      }
    }, displayCount)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      direction: 'row',
      alignItems: 'center',
      alignContent: 'center',
      justify: 'center',
      spacing: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 33
      }
    }, "Results per page: ")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 40,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Select, {
      value: state.pageSize,
      onChange: event => {
        changePageSize(self, event.target.value);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 33
      }
    }, VALID_PAGE_SIZES.map(size => /*#__PURE__*/React.createElement(MenuItem, {
      value: size,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 41
      }
    }, size)))))], /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignItems: 'center',
      justify: 'center',
      alignContent: 'center',
      wrap: 'nowrap',
      direction: 'row',
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => loadFirstPage(self),
      disabled: state.page === 0,
      "aria-label": "First Page",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(FirstPage, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => loadPreviousPage(self),
      disabled: state.page === 0,
      "aria-label": "Previous Page",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(KeyboardArrowLeft, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 25
      }
    }, state.loaded != null && state.loaded === false ? /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 33
      }
    }, "Loading...") : /*#__PURE__*/React.createElement(Typography, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 33
      }
    }, displayPage)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => loadNextPage(self),
      disabled: state.morePages === false,
      "aria-label": "Next Page",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(KeyboardArrowRight, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 80,
        columnNumber: 33
      }
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 83,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      onClick: () => loadFinalPage(self),
      disabled: state.page >= state.totalPages - 1,
      "aria-label": "Last Page",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 84,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(LastPage, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 88,
        columnNumber: 33
      }
    }))))));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 16
      }
    });
  }
}
function changePageSize(instance, pageSize) {
  instance.state.pageSize = pageSize;
  changeSearchValue(Q_STRING.SIZE, pageSize, instance.props);
  resetFailures(instance);
  storeUserPreferenceInLocalStorage(LOCAL_STORAGE_ITEM_NAMES.preferredPageSize, pageSize);
  instance.loadContent();
}
function loadFirstPage(instance) {
  instance.state.page = 0;
  changeSearchValue(Q_STRING.PAGE, 1, instance.props);
  resetFailures(instance);
  instance.loadContent();
}
function loadNextPage(instance) {
  if (instance.state.morePages === true) {
    instance.state.page = instance.state.page + 1;
    changeSearchValue(Q_STRING.PAGE, instance.state.page + 1, instance.props);
    resetFailures(instance);
    instance.loadContent();
  }
}
function loadFinalPage(instance) {
  instance.state.page = instance.state.totalPages - 1;
  changeSearchValue(Q_STRING.PAGE, instance.state.page + 1, instance.props);
  resetFailures(instance);
  instance.loadContent();
}
function loadPreviousPage(instance) {
  if (instance.state.page > 0) {
    instance.state.page = instance.state.page - 1;
    changeSearchValue(Q_STRING.PAGE, instance.state.page + 1, instance.props);
    resetFailures(instance);
    instance.loadContent();
  }
}
function resetFailures(instance) {
  instance.state.failures = null;
}